/* This file is based on `vscode-lean4/vscode-lean4/src/abbreviation/rewriter/TrackedAbbreviation.ts` */
/**
 * Represents an abbreviation that is tracked and currently typed by the user.
 * When the multi-cursor feature is used, multiple abbreviations can be tracked at once.
 */
var TrackedAbbreviation = /** @class */ (function () {
    function TrackedAbbreviation(abbreviationRange, _text, abbreviationProvider) {
        this._text = _text;
        this.abbreviationProvider = abbreviationProvider;
        this._finished = false;
        this._abbreviationRange = abbreviationRange;
    }
    Object.defineProperty(TrackedAbbreviation.prototype, "abbreviationRange", {
        get: function () {
            return this._abbreviationRange;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TrackedAbbreviation.prototype, "range", {
        get: function () {
            return this.abbreviationRange.moveKeepEnd(-1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TrackedAbbreviation.prototype, "abbreviation", {
        get: function () {
            return this._text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TrackedAbbreviation.prototype, "matchingSymbol", {
        get: function () {
            return this.abbreviationProvider.getReplacementText(this.abbreviation);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TrackedAbbreviation.prototype, "isAbbreviationUniqueAndComplete", {
        /**
         * Does this abbreviation uniquely identify a symbol and is it complete?
         */
        get: function () {
            return (this.abbreviation !== "" && // Check empty string for speed up
                this.abbreviationProvider.findSymbolsByAbbreviationPrefix(this.abbreviation).length === 1 &&
                !!this.abbreviationProvider.getSymbolForAbbreviation(this.abbreviation));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TrackedAbbreviation.prototype, "finished", {
        /**
         * Indicates whether this abbreviation has been continued with non-abbreviation characters.
         * Such abbreviations should be replaced immediately.
         */
        get: function () {
            return this._finished;
        },
        enumerable: false,
        configurable: true
    });
    TrackedAbbreviation.prototype.processChange = function (range, newText) {
        if (this.abbreviationRange.containsRange(range)) {
            this._finished = false;
            if (this.abbreviationRange.isBefore(range)) {
                // `newText` is appended to `this.abbreviation`
                if (this.abbreviationProvider.findSymbolsByAbbreviationPrefix(this.abbreviation + newText).length === 0) {
                    // newText is not helpful anymore. Finish this and don't accept the change.
                    this._finished = true;
                    return {
                        shouldStopTracking: false,
                        isAffected: false,
                    };
                }
            }
            this._abbreviationRange = this.abbreviationRange.moveEnd(newText.length - range.length);
            var startStr = this.abbreviation.substr(0, range.offset - this.abbreviationRange.offset);
            var endStr = this.abbreviation.substr(range.offsetEnd + 1 - this.abbreviationRange.offset);
            this._text = startStr + newText + endStr;
            return { shouldStopTracking: false, isAffected: true };
        }
        else if (range.isBefore(this.range)) {
            // The changed happened before us. We need to move.
            this._abbreviationRange = this._abbreviationRange.move(newText.length - range.length);
            return { shouldStopTracking: false, isAffected: false };
        }
        else if (range.isAfter(this.range)) {
            // The change does not affect us.
            return { shouldStopTracking: false, isAffected: false };
        }
        else {
            // We cannot process the change. Abort tracking.
            return { shouldStopTracking: true, isAffected: false };
        }
    };
    return TrackedAbbreviation;
}());
export { TrackedAbbreviation };
